<template>
  <ol class="contact-list">
    <li
      :id="item.title"
      class="pb-m pl-s"
      :key="item.title"
      v-for="item in list"
    >
      <h4 class="font-rg pb-xs" v-text="item.title"></h4>
      <h6 v-if="item.content" class="font-rg pb-s" v-text="item.content"></h6>
      <div class="info-line ">
        <i class="fas fa-map-marker-alt text-gray-7"></i>
        <!-- <i class="fad fa-map-marker text-gray-9"></i> -->
        <span v-html="item.description"></span>
      </div>
      <template v-if="hasPhone(item.phone)">
        <a
          class="info-line "
          :key="num"
          v-for="num in parsePhones(item.phone)"
          :href="`tel:${num}`"
        >
          <i class="fas fa-phone-rotary text-gray-7"></i>
          <span v-text="num" />
        </a>
      </template>
      <template v-if="hasEmail(item.email)">
        <a
          class="info-line "
          :key="e"
          v-for="e in item.email"
          :href="`mailto:${e}`"
        >
          <i class="fas fa-envelope text-gray-7"></i>
          <span v-text="e" />
        </a>
      </template>
      <template v-if="hasWebsite(item.website)">
        <a
          class="info-line "
          :key="site"
          v-for="site in item.website"
          :href="item.website"
          target="_blank"
        >
          <i class="fas fa-external-link text-gray-7"></i>
          <span v-text="site" />
        </a>
      </template>
      <template v-if="item.children.length>0">
        <a
          class="info-line "
          :key="linkItem"
          v-for="linkItem in item.children"
          :href="linkItem.url"
          target="_blank"
        >
          <i class="fas fa-external-link text-gray-7"></i>
          <span v-text="linkItem.title" />
        </a>
      </template>      
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    continent: {
      type: String,
      required: false
    },
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    hasEmail(email) {
      let list = _.compact(email);
      return list && list.length;
    },
    hasPhone(phone) {
      let list = _.compact(phone);
      return list && list.length;
    },
    hasWebsite(website) {
      let list = _.compact(website);
      return list && list.length;
    },
    parsePhones(phone) {
      let list = _.compact(phone);
      list = list.toString().replace(/[A-Za-z:]*/g, '').split(",");
      // console.log("PHONELIST >> ", list);
      return list
    }

  }
};
</script>

<style lang="stylus" scoped>
h5
    font-weight 700
    margin-bottom 5px
li.active
  background rgba(blue_3, 0.1)
+desktop()
  li:hover
    background rgba(blue_3, 0.1)
.info-line
  _flex(row, nowrap, baseline, flex-start)
  pad('xs', bottom)
  i
    width 20px
    font-size 80%
    opacity 0.65
    display block
    flex none
    text-align center
    margin-right 3px
</style>
